import { SyntheticEvent } from "react";
import { Dropdown, DropdownItemProps, DropdownProps } from "semantic-ui-react";
import { CSSProperties } from "styled-components";

interface Props {
	options: DropdownItemProps[];
	onChange?: (
		event: SyntheticEvent<HTMLElement, Event>,
		data: DropdownProps
	) => void;
	value?: string;
	containerClass?: string;
	containerStyle?: CSSProperties;
}

const CountriesDropdown: React.FC<Props> = (props) => {
	const { options, value, onChange, containerClass, containerStyle } = props;

	return (
		<div
			className={`container ${containerClass}`}
			style={containerStyle}
			id="semantic-ui-wrapper"
		>
			<Dropdown
				placeholder="Nazione"
				fluid
				search
				selection
				value={value?.toLowerCase()}
				options={options}
				onChange={onChange}
			/>
		</div>
	);
};

export default CountriesDropdown;
